import connections from "./connections"
import applet from "./applet"
import config from "./config"
import user from "./user"
import error from "./error"
import logging from "./logging"
import animation from "./animation"

const reducers = {
  connections,
  applet,
  user,
  config,
  error,
  logging,
  animation,
}

export default reducers
